import { FaChevronLeft, FaChevronRight, FaSearchPlus } from 'react-icons/fa';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { IoLogoAndroid, IoMdClose, IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { FaChevronDown } from 'react-icons/fa';
import { FaChevronUp } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa';
import { FaRegPlusSquare } from 'react-icons/fa';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { FaTv } from 'react-icons/fa';
import { RxCross2 } from 'react-icons/rx';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { BiLoaderCircle } from 'react-icons/bi';
import { FaHandPointDown } from 'react-icons/fa';
import { FaSignInAlt } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { VscTriangleDown } from 'react-icons/vsc';
import { FiCalendar } from 'react-icons/fi';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { IoChevronBackSharp, IoChevronForwardSharp, IoWalletOutline } from 'react-icons/io5';
import { RiBankFill } from 'react-icons/ri';
import { FaTrophy } from 'react-icons/fa';
import { PiSpeakerSimpleHighBold } from 'react-icons/pi';
import { IoIosInformationCircle } from 'react-icons/io';
import { FaLocationArrow } from 'react-icons/fa6';
import { IoPersonSharp } from 'react-icons/io5';
import { TbLadder } from 'react-icons/tb';
import { PiStopCircleFill } from 'react-icons/pi';
export const Icons = {
  Trophy: FaTrophy,
  Android: IoLogoAndroid,
  SearchPlus: FaSearchPlus,
  Down: FaChevronDown,
  Up: FaChevronUp,
  Menu: FaBars,
  PlusSquare: FaRegPlusSquare,
  MinusSquare: AiOutlineMinusSquare,
  Close: IoIosCloseCircleOutline,
  Tv: FaTv,
  Cross: RxCross2,
  Eye: FaEye,
  EyeSlash: FaEyeSlash,
  Home: FaHome,
  Loading: BiLoaderCircle,
  PointDown: FaHandPointDown,
  SignIn: FaSignInAlt,
  Lock: FaLock,
  TriangleDown: VscTriangleDown,
  Calendar: FiCalendar,
  Back: FaChevronLeft,
  Forward: FaChevronRight,
  calendar: MdOutlineCalendarMonth,
  chevronBack: IoChevronBackSharp,
  chevronForward: IoChevronForwardSharp,
  openEye: IoMdEye,
  closeEye: IoMdEyeOff,
  previous: FaArrowLeft,
  next: FaArrowRight,
  close: IoMdClose,
  wallet: IoWalletOutline,
  bank: RiBankFill,
  info: IoIosInformationCircle,
  speaker: PiSpeakerSimpleHighBold,
  arrow: FaLocationArrow,
  profile: IoPersonSharp,
  ladder: TbLadder,
  circle: PiStopCircleFill,
};
